import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent {

  faTimes = faTimes

  @Input() removeIcon: boolean = false
  @Input() color: string = "blue"

  @Output() remove: EventEmitter<null> = new EventEmitter<null>()
  @Output() tagClick: EventEmitter<null> = new EventEmitter<null>()

  onRemove() {
    this.remove.emit()
  }

  onClick(event: MouseEvent) {
    this.tagClick.emit()
  }

}
